import target from './stagingTarget.json'

export function isStagingTestMode() {
  return process.env.REACT_APP_STAGING_TEST_MODE === 'true'
}

export function isOutboundTestMode() {
  return isStagingTestMode() || process.env.REACT_APP_LOCAL_TEST_MODE === 'true'
}

export const stagingEmailMessage = 'Hosted test mode: account emails are disabled. Use your supplied test account.'

export function assertStagingFrontendIsolation(env) {
  const staging = env.enabled === 'true' || env.supabaseUrl === target.databaseUrl || env.siteUrl === target.origin
  if (!staging) return
  if (env.enabled !== 'true' || env.supabaseUrl !== target.databaseUrl || env.siteUrl !== target.origin) {
    throw new Error('Hosted test mode refused an unapproved site or database.')
  }
  if (env.localMode === 'true' || env.fixtureMode === 'true' || env.stripeKey) {
    throw new Error('Hosted test mode requires fixtures and provider access to be disabled.')
  }
}
